"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.globalSettings = void 0;
var utils_1 = require("./utils/utils");
var defaultSettings_1 = require("./defaultSettings");
var ConsentHandler_1 = require("./classes/consent/ConsentHandler");
require("./classes/User");
require("./classes/Session");
var Page_1 = require("./classes/Page");
var UserSync_1 = require("./classes/UserSync");
require("./styles/sass/main.sass");
var Session_1 = require("./classes/Session");
var Analytics_1 = require("./classes/Analytics");
var AnalyticsPrebid_1 = require("./classes/AnalyticsPrebid");
var log_1 = require("./utils/log");
var bigcrunchtag = globalThis.bigcrunchtag || {};
bigcrunchtag.cmd = bigcrunchtag.cmd || [];
// Execute all commands in the queue
bigcrunchtag.cmd.forEach(function (fn) {
    fn.call();
});
// Replace the queue with a function that executes commands immediately
bigcrunchtag.cmd.push = function (fn) {
    fn.call();
};
function init(settings) {
    var _a;
    // Set options
    exports.globalSettings = (0, utils_1.deepMerge)(defaultSettings_1.defaultSettings, settings);
    // detect bots
    if ((0, utils_1.checkIsBot)()) {
        var error_message = "Bot Detected";
        (0, log_1.logWarn)(error_message);
        // Create a new standard Error object
        var error = new Error(error_message);
        // Send error analytics
        Analytics_1.globalAnalytics.sendErrorAnalytics(error, 'BOT_DETECTED');
        return;
    }
    // Check if should track prebid analytics
    if ((_a = exports.globalSettings === null || exports.globalSettings === void 0 ? void 0 : exports.globalSettings.analytics) === null || _a === void 0 ? void 0 : _a.prebid_analytics) {
        // Init Prebid Analytics
        new AnalyticsPrebid_1.AnalyticsPrebid();
    }
    // Init Session 
    Session_1.globalSession.getSessionId();
    // Init Page
    Page_1.globalPage.init();
    // Queue commands for execution when consent is ready
    ConsentHandler_1.allConsentHandler.cmd.push(function () {
        // Sync users
        UserSync_1.globalUserSync.syncUsers(exports.globalSettings.user_syncs, exports.globalSettings.bidders);
        // TODO: Run Indentity Adapters
    });
    // check test config
    checkTestConfig();
    // Build slots
    var slots = exports.globalSettings.slots || {};
    // check if slots exist
    if (Object.keys(slots).length) {
        if (document.readyState === 'complete' || document.readyState === 'interactive') {
            Page_1.globalPage.buildSlots(slots);
        }
        else if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', function () {
                Page_1.globalPage.buildSlots(slots);
            });
        }
    }
}
/**
 * @description Check test config
 */
function checkTestConfig() {
    // check url search params
    var urlParams = new URLSearchParams(window.location.search);
    // check if test ids are enabled
    if (urlParams.get('bc_test_ids') === 'true') {
        // set test ids
        exports.globalSettings.test.ids = true;
        // set test enabled
        exports.globalSettings.test.enabled = true;
    }
    // check if test ads are enabled
    if (urlParams.get('bc_test_ads') === 'true') {
        // set test ads
        exports.globalSettings.test.ads = true;
        // set test enabled
        exports.globalSettings.test.enabled = true;
    }
    // check if test bidders are enabled
    if (urlParams.get('bc_test_bidders')) {
        // set test bidders
        exports.globalSettings.test.bidders = urlParams.get('bc_test_bidders').split(',');
        // set test enabled
        exports.globalSettings.test.enabled = true;
    }
    // check if test ads are enabled
    if (urlParams.get('bc_test_log') === 'true') {
        // set test ads
        exports.globalSettings.test.log = true;
        // set test enabled
        exports.globalSettings.test.enabled = true;
    }
}
/**
 *
 * @param {TestConfig} testConfig
 * @description Set test config
 * @example
 * BCLighthouseTag.setTestConfig({
 *   ids: true,
 *   ads: true,
 *   bidders: ['freewheel']
 * });
 */
function setTestConfig(testConfig) {
    if (testConfig) {
        if (testConfig.ids) {
            // set test ids
            exports.globalSettings.test.ids = true;
        }
        if (testConfig.ads) {
            // set test ads
            exports.globalSettings.test.ads = true;
        }
        if (testConfig.bidders) {
            // set test bidders
            exports.globalSettings.test.bidders = testConfig.bidders;
        }
        // set test enabled
        exports.globalSettings.test.enabled = true;
    }
}
// Expose functions to global scope
globalThis.BCLighthouseTag = {
    init: init,
    setTestConfig: setTestConfig,
};
init({
    "property_id": "7baaa297-8659-496c-ab3a-63eff8584214",
    "site_name": "snopes",
    "gam_advertiser_ids": {
        "5363417171": "prebid_ads",
        "4430894621": "google_ad_exchange",
        "4470907880": "amazon",
        "4649008221": "kargo",
        "5364246857": "big_crunch"
    },
    "analytics": {
        "bigcrunch": true,
        "prebid_analytics": true,
        "bigcrunch_page_meta": true,
        "url_path_groupings": [
            "/search/"
        ],
        "page_meta_overrides": {
            "/search/": {
                "author": "",
                "title": "Search Results",
                "thumbnailUrl": "",
                "articleSection": "",
                "keywords": "",
                "dateCreated": "",
                "dateModified": "",
                "datePublished": ""
            }
        }
    },
    "slots": {
        "snopes_outstream": {
            "id": "snopes_outstream_id",
            "name": "snopes_outstream",
            "css_selector": "#bigcrunch_outstream_video",
            "floor": 1.00,
            "refresh": {
                "enabled": true,
                "interval": 15000,
                "inview_interval": 5000
            },
            "lazyload": {
                "enabled": true,
                "fetch_threshold": 100,
                "display": 50
            },
            "auto_delete": {
                "enabled": false,
                "threshold": 150
            },
            "sticky": {
                "enabled": true
            },
            "resolutionSizes": {
                "0": ["400x300"],
                "500": ["400x300"],
                "970": ["400x300", "640x360"]
            }
        }
    },
    "bidders": {
        "freewheel": {
            "config": {
                "enabled": true,
                "demand_type": "video",
                "video_type": "outstream",
                "endpoint_id": "31dd",
                "zone_id": "33727722"
            },
            "slots": {
                "snopes_outstream": {
                    "snopes_outstream": ["640x360"]
                }
            }
        },
        "magnite": {
            "config": {
                "enabled": true,
                "demand_type": "video",
                "video_type": "outstream",
                "account_id": "17066",
                "site_id": "516470",
                "zone_id": "3103316"
            },
            "slots": {
                "snopes_outstream": {
                    "snopes_outstream": ["400x300"]
                }
            }
        },
        "ix": {
            "config": {
                "enabled": true,
                "demand_type": "video",
                "video_type": "outstream",
                "endpoint_id": "snopes",
                "site_id": "1042149"
            },
            "slots": {
                "snopes_outstream": {
                    "snopes_outstream": ["400x300"]
                }
            }
        },
        "nexxen": {
            "config": {
                "enabled": true,
                "demand_type": "video",
                "video_type": "outstream",
                "endpoint_id": "snopes"
            },
            "slots": {
                "snopes_outstream": {
                    "snopes_outstream": ["400x300"]
                }
            }
        },
        "pubmatic": {
            "config": {
                "enabled": true,
                "demand_type": "video",
                "video_type": "outstream",
                "publisher_id": "164047"
            },
            "slots": {
                "snopes_outstream": {
                    "5524964": ["400x300"]
                }
            }
        }
    },
    "user_syncs": {
        "freewheel": {
            "sync_id": "3688"
        },
        "ix": {
            "site_id": "207140"
        },
        "nexxen": {
            "sub": "snopes"
        },
        "magnite": {
            "partner_key": "pbs-salon"
        },
        "pubmatic": {
            "publisher_id": "164047"
        }
    }
});
// init({
//     "property_id": "34a5ddec-697b-424e-81d2-e6bb46a1b83e",
//     "site_name": "tvtropes",
//     "gam_advertiser_ids": {
//         "5363417171": "prebid_ads",
//         "4430894621": "google_ad_exchange",
//         "4470907880": "amazon",
//         "4649008221": "kargo",
//         "5364246857": "big_crunch",
//     },
//     "analytics": {
//         "bigcrunch": true,
//         "prebid_analytics": true,
//         "bigcrunch_page_meta": false,
//         "url_path_groupings": [],
//         "page_meta_overrides": {
//             "/pmwiki/topics.php": {
//                 "title": "Forum Topics",
//             },
//             "/pmwiki/factivity2.php": {
//                 "title": "Forum Activity",
//             },
//             "/search/pmwiki/conversations.php": {
//                 "title": "Forum Conversations",
//             },
//             "/pmwiki/posts.php": {
//                 "title": "Forum Posts",
//             }
//         }
//     },
//     "slots": {},
//     "bidders": {},
//     "user_syncs": {}
// });
// init({
//     "property_id": "d88c0c4e-8250-4202-9ce8-88226fb393bf",
//     "site_name": "salon",
//     "gam_advertiser_ids": {
//         "5363417171": "prebid_ads",
//         "4430894621": "google_ad_exchange",
//         "4470907880": "amazon",
//         "4649008221": "kargo",
//         "5364246857": "big_crunch",
//     },
//     "analytics": {
//         "bigcrunch": true,
//         "prebid_analytics": true,
//         "bigcrunch_page_meta": true
//     },
//     "slots": {},
//     "bidders": {},
//     "user_syncs": {}
// });
